import apiClient from "./apiClient";

const BASE = "/api/Procedure";

export const getProcedures = () => apiClient.get(`${BASE}/all`);
export const getActiveProcedures = () => apiClient.get(`${BASE}/active`);
export const getProcedure = (id) => apiClient.get(`${BASE}/${id}`);
export const createProcedure = (data) => apiClient.post(`${BASE}/save`, data);
export const updateProcedure = (id, data) => apiClient.post(`${BASE}/save`, { ...data, procedureID: id });
export const deleteProcedure = () => Promise.reject(new Error("Delete not supported by API"));
